/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolDeployedCodeIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-deployed-code"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M10.68 22.48L3.52 18.38Q2.9 18.02 2.55 17.41Q2.2 16.8 2.2 16.07L2.2 7.95Q2.2 7.22 2.55 6.61Q2.9 6 3.52 5.65L10.68 1.55Q11.3 1.2 12 1.2Q12.7 1.2 13.32 1.55L20.45 5.65Q21.07 6 21.43 6.61Q21.77 7.22 21.77 7.95L21.77 16.07Q21.77 16.8 21.43 17.41Q21.07 18.02 20.45 18.38L13.32 22.48Q12.7 22.82 12 22.82Q11.3 22.82 10.68 22.48ZM10.7 12.8L10.7 19.4L12 20.15Q12 20.15 12 20.15Q12 20.15 12 20.15L13.32 19.38L13.32 12.78L19.13 9.4L19.13 8Q19.13 8 19.13 8Q19.13 8 19.13 8L17.73 7.17L12 10.5L6.28 7.17L4.85 8Q4.85 8 4.85 8Q4.85 8 4.85 8L4.85 9.38Z" fill={color} />
    </svg>
  );
}
